import { UserRole } from './users.entity';

export const MAX_USER_LEVEL = 50;

const sortedRoles: string[] = Object.keys(UserRole);

export function getUserPrimaryRole(roles: string[]|undefined): string {
  if(!roles) {
    return 'ROLE_USER';
  }

  const role: string = roles.sort((a: string, b: string) => sortedRoles.indexOf(a) - sortedRoles.indexOf(b))[0];

  if([
    'ROLE_ANALYTICS',
    'ROLE_ADV_MANAGER',
    'ROLE_SMM'
  ].includes(role)) {
    return 'ROLE_USER';
  }

  return role;
}

export function calcLevelExp(level: number, baseExp: number = 3019, exponent = 1.35): number {
  return Math.floor(baseExp * (level ** exponent));
}